import React from 'react';
import { Ban } from 'lucide-react';

interface BlockUnblockButtonProps {
  isBlocked: boolean;
  onClick: () => void;
}

const BlockUnblockButton: React.FC<BlockUnblockButtonProps> = ({ isBlocked, onClick }) => {
  return (
    <div className="relative group">
      <button
        className="text-gray-600 hover:text-yellow-600"
        onClick={onClick}
        title={isBlocked ? 'Unblock' : 'Block'}
      >
        <Ban className="w-4 h-4" />
      </button>
      <span className="absolute -top-7 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        {isBlocked ? 'Unblock' : 'Block'}
      </span>
    </div>
  );
};

export default BlockUnblockButton;
